/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: callbackProfilesActions.ts
 🗓️ Created: 2026-05-02
 🧩 Description:
    Implementation of the PBX Call Center module.
────────────────────────────────────────────────────────────────*/

import type { NavigateFunction } from 'react-router-dom';
import { deleteCallbackProfile } from './api';

/**
 * Shared helpers for Callback Profiles module actions (used in Grid + Form views).
 */

/**
 * Build the URL used to duplicate a Callback Profile in the form.
 * Pattern: /pbx/call-center/callback-profiles/new?duplicate={id}
 */
export const getCallbackProfileDuplicateUrl = (id: string | number): string =>
  `/pbx/call-center/callback-profiles/new?duplicate=${id}`;

/**
 * Navigate to the form in duplicate mode for the given Callback Profile id.
 */
export const navigateToCallbackProfileDuplicate = (
  navigate: NavigateFunction,
  id: string | number,
): void => {
  navigate(getCallbackProfileDuplicateUrl(id));
};

/**
 * Low-level API helper to delete a Callback Profile by id.
 * UI components are responsible for showing notifications and handling navigation/refresh.
 */
export const deleteCallbackProfileById = async (id: string | number): Promise<void> => {
  await deleteCallbackProfile(id);
};



